import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  headerContainer: {
    padding: 10,
    // borderBottomColor: '#C8C8C8',
    // borderBottomWidth: 1,
    borderColor: '#F5F5F5',
    borderWidth: 1,
    marginTop: 10,
    backgroundColor: '#F5F5F5',
  },
  billTo: {
    // color: '#000',
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,  // Added margin for spacing
    
  },
  cancellationpolicy: {
    // color: '#000',
    fontSize: 9,
    fontWeight: 100,
    lineHeight: 1.5, // Improved line spacing for readability
    marginBottom: 5, // Added margin to separate the cancellation text
  },
});

let getDateModal = (data, selectedDate) => {
  let DataNew = '';
  const selectActivityDay = selectedDate;

  if (data[0].cancellation_penalty_id === 1) {
    const date = new Date(selectActivityDay);
    DataNew =
      'Free Cancellation (100% refund) if you cancel this booking on or before the start of experience (tour, event, attraction, activity). ';
  } else if (data[0].cancellation_penalty_id === 3) {
    DataNew =
      'Minimum ' +
      data[0].cancellation_value +
      '% cancellation charges applicable';
  }
  return DataNew;
};

let CancellationModal = (data, selectedDate) => {
  let DataNew = '';
  let Value = '';
  let EuroIcon = '';
  let PerIcon = '';

  return (
    <Text >
      {' '}
      {data
        .slice(0)
        .reverse()
        .map((i, index) => {
          const selectActivityDay = selectedDate;
          const date = new Date(selectActivityDay);
          if (i.day_before_arrival === 1 || i.day_before_arrival === 2) {
            date.setDate(date.getDate() - i.day_before_arrival);
            DataNew = moment(date).format('Do MMM YYYY');
          } else {
            date.setDate(date.getDate() - (i.day_before_arrival - 2));
            DataNew =
              'If cancelled or modified ' +
              parseInt(i.day_before_arrival - 2) +
              ' days before date of experience (tour, event, attraction, activity). ';
          }

          if (i.penalty === 'No Penalty') {
            Value = 0;
            EuroIcon = '';
            PerIcon = '';
          } else if (i.penalty === 'Full Amount') {
            Value = '';
            EuroIcon = '';
            PerIcon = ' Full booking amount will be charged. ';
          } else if (i.penalty === 'Percentage') {
            Value = i.cancellation_value;
            EuroIcon = '';
            PerIcon = '% of booking amount will be charged. ';
          } else if (i.penalty === 'Nights') {
            Value = i.cancellation_value;
            EuroIcon = <span>€</span>;
            PerIcon = ' amount will be charged. ';
          } else if (i.penalty === 'Fixed Amount') {
            Value = i.cancellation_value;
            EuroIcon = <span>€</span>;
            PerIcon = ' amount will be charged. ';
          }

          if (i.day_before_arrival === 1) {
            DataNew = ' In case of no show ';
          }

          return (
            <Text key={index}>
              <Text style={styles.cancellationpolicy}>
                {DataNew}
              </Text>
              <Text style={styles.cancellationpolicy}>
                {EuroIcon} {Value}
                {PerIcon}
              </Text>
            </Text>
          );
        })}
    </Text>
  );
};

const CancellationExperience = ({ invoice }) => {
  const selectedDate = invoice.tour_booking_date;
  const items1 = JSON.stringify(invoice?.cancellation_policy);
  const items2 = JSON.parse(items1);
  const items3 = JSON.parse(items2);

  const rowsCancel =
    items3 &&
    items3?.cancellation_policy.map((item, index) => {
      return item[0].cancellation_penalty_id === 1 ? (
        <Text style={styles.billTo} key={index}>
          {getDateModal(item, selectedDate)} <br />
        </Text>
      ) : (
        <Text style={styles.billTo} key={index}>
          {CancellationModal(item, selectedDate)} <br />
        </Text>
      );
    });

  return (
    <View style={{backgroundColor:'#f5f5f5', padding:5, marginTop:5}}>
      <Text style={{fontSize:11, marginBottom:5}}>Cancellation Policy: </Text>
      {rowsCancel}
    </View>
  );
};

export default CancellationExperience;
